import {isBrandVisibleToUser} from '../../../utils/brands/brandVisibility.js';

export const SHOPTET_ADDON_MARKETPLACE_URL = 'https://doplnky.shoptet.cz/datixo';
export const UPGATES_ADDON_MARKETPLACE_URL = 'https://doplnky.upgates.cz/detail/datixo';

export function getInitialEshopPlatforms({
    erpBrands,
    leadBrands,
    shoptetAddonBrand,
    upgatesAddonBrand,
    isAdministrator,
}) {
    const bsshop = erpBrands.find((brand) => brand.slug === 'bsshop');
    const legacyShoptetXml = erpBrands.find((brand) => brand.slug === 'shoptet');
    const mysqlLead = leadBrands.find((brand) => brand.slug === 'mysql');
    const marketplaceChoice = (brand, name, href) => brand
        ? {brand: {...brand, name}, href}
        : null;

    return [
        bsshop ? {brand: bsshop} : null,
        marketplaceChoice(shoptetAddonBrand, 'Shoptet', SHOPTET_ADDON_MARKETPLACE_URL),
        marketplaceChoice(upgatesAddonBrand, 'Upgates', UPGATES_ADDON_MARKETPLACE_URL),
        legacyShoptetXml && isBrandVisibleToUser(legacyShoptetXml, isAdministrator)
            ? {brand: {...legacyShoptetXml, name: 'XML'}}
            : null,
        isAdministrator && mysqlLead ? {brand: mysqlLead} : null,
    ].filter(Boolean);
}

export function getIntegrationDisplayName(brand) {
    return brand?.isLegacyXml === true && brand.slug === 'shoptet'
        ? 'XML'
        : brand?.name ?? '';
}

export function getConfiguredIntegrationName(integrationName, brand) {
    return brand?.isLegacyXml === true && brand.slug === 'shoptet'
        ? 'XML'
        : brand?.name ?? integrationName;
}

export function sortConfiguredIntegrations(integrations, brands) {
    return (integrations ?? [])
        .map((integration, index) => ({
            integration,
            index,
            brand: brands[integration.name],
            displayName: getConfiguredIntegrationName(integration.name, brands[integration.name]),
        }))
        .sort((left, right) => {
            const leftPriority = left.brand?.isERP === true || left.brand?.isLead === true ? 0 : 1;
            const rightPriority = right.brand?.isERP === true || right.brand?.isLead === true ? 0 : 1;

            if (leftPriority !== rightPriority) return leftPriority - rightPriority;

            const byDisplayName = left.displayName.localeCompare(right.displayName, 'cs', {sensitivity: 'base', numeric: true});
            return byDisplayName || left.index - right.index;
        })
        .map(({integration}) => integration);
}

export function getConfiguredIntegrationGroups(integrations, brands) {
    const groups = new Map([
        ['shop-and-leads', []],
        ['marketing', []],
        ['data-and-analytics', []],
        ['other', []],
    ]);

    for (const integration of integrations ?? []) {
        const brand = brands[integration.name];
        const group = brand?.isERP === true || brand?.isLead === true
            ? 'shop-and-leads'
            : brand?.isAdSystem === true
                ? 'marketing'
                : brand?.isGoogleData === true
                    ? 'data-and-analytics'
                    : 'other';
        groups.get(group).push(integration);
    }

    return [...groups.entries()]
        .filter(([, items]) => items.length > 0)
        .map(([key, items]) => ({key, integrations: sortConfiguredIntegrations(items, brands)}));
}
